import { Box, Button, Text, TextField, TextFieldSize } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { width as listWidth } from '../list/styled';

export const UserDetailContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
})`
  width: calc(100% - ${listWidth});
`;
export const SepartorStyled = styled(Box)`
  ${({ theme }) => css`
    border-bottom: solid 1px ${theme.colors.grey[300]};
  `}
`;

export const UserDetailFooterStyled = styled(Box).attrs({
  py: { sm: '500' },
  pr: { sm: '500' },
  justifyContent: { sm: 'flex-end' },
})`
  background-color: ${({ theme }) => theme.colors.blue[800]};
`;
export const HeadingStyled = styled(Text).attrs({
  size: '400',
  color: 'grey.1000',
  family: 'graphik',
})`
  padding-top: ${({ theme }) => theme.spacings[100]};
  padding-bottom: ${({ theme }) => theme.spacings[100]};
  white-space: nowrap;
`;

export const HeaderStyled = styled(Box).attrs({
  px: { sm: '600' },
  pb: { sm: '500' },
  pt: { sm: '500' },
  justifyContent: { sm: 'space-between' },
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    background: ${theme.colors.grey[100]};
    border-bottom: solid 1px ${theme.colors.grey[300]};
    @media only screen and (max-height: ${({ theme }) => theme.breakpoints.tablet}) and (max-width: ${({ theme }) =>
        theme.breakpoints.desktop}) {
      flex-wrap: wrap;
      span {
        margin-bottom: ${({ theme }) => theme.spacings['450']};
      }
    }
  `}
`;
export const HeaderUserDetailStyled = styled(Box).attrs({
  px: { sm: '600' },
  pb: { sm: '600' },
  pt: { sm: '600' },
  mb: { sm: '500' },
  justifyContent: { sm: 'space-between' },
})`
  ${({ theme }) => css`
    background: ${theme.colors.grey[100]};
    border-bottom: solid 1px ${theme.colors.grey[300]};
    border-top: solid 1px ${theme.colors.grey[300]};
  `}
`;
export const FooterButtonStyled = styled(Button)`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding-right: ${theme.spacings[600]};
    padding-left: ${theme.spacings[600]};
    width: auto;
  `}
`;

export const TextFieldStyled = styled(TextField).attrs({ size: TextFieldSize.LARGE })`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[300]};
    font-family: ${theme.fontFamilies['graphik']};
  `}
`;
